import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { ROUND_STATUSES } from '@/containers/RoundHistory/constants';
import { historyService } from '../../services/historyService';

export const useGetAllRounds = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.history.all_rounds],
    queryFn: () =>
      historyService.allRounds().then(response => {
        const { status } = response;
        if (status === 200) {
          return response.data.filter(
            r =>
              ![
                ROUND_STATUSES.upcoming.code,
                ROUND_STATUSES.in_progress.code,
              ].includes(r.status),
          );
        }
        throw new Error('Fetch failed');
      }),
  });
};
